import { Component, Input, SimpleChanges } from '@angular/core';
import { AppSettings } from '../app.settings';
import { environment } from '../../environments/environment';

@Component({
  selector: 'designation-more-info',
  template: `
    <div
      *ngIf="featureEnabled && hasPreviewContent"
      id="designation-preview"
      class="preview-container"
    >
      <p
        *ngIf="
          !imageUrl.length &&
          !visibleAttributes.length &&
          !moreInfoDesignation.length
        "
      >
        This Designation has no preview
      </p>
      <div *ngIf="imageUrl" class="image-container">
        <img src="{{ imageUrl }}" />
      </div>
      <div class="preview-description">
        <div class="title">{{ moreInfoDesignation.title }}</div>
        <ul class="attribute-codes">
          <li *ngFor="let attr of visibleAttributes" class="attribute">
            {{ attr.value }}
          </li>
        </ul>
        <p>{{ moreInfoDesignation.summary }}</p>
      </div>
    </div>
  `
})
export class DesignationMoreInfoComponent {
  @Input() moreInfoDesignationId: any = null;
  featureEnabled = false;
  hasPreviewContent = false;
  visibleAttributes: any = [];
  imageUrl: string = null;
  moreInfoDesignation: any = {};
  availableDesignations: any = [];
  ngOnChanges(changes: SimpleChanges) {
    this.visibleAttributes = null;
    this.imageUrl = '';
    if (this.featureEnabled) {
      this.moreInfoDesignation = this.availableDesignations.find(
        a => a.id == changes.moreInfoDesignationId.currentValue
      );
      if (this.moreInfoDesignation) {
        if (this.moreInfoDesignation.attributes) {
          this.visibleAttributes = this.moreInfoDesignation.attributes
            .filter((item, index) => item.public_visible)
            .sort((a, b) => (a.name < b.name ? -1 : 1))
            .slice(0, 3);
        }
        this.imageUrl = this.generateImageUrl(
          this.moreInfoDesignation.image_key
        );
      }
    }
    if (
      this.imageUrl.length > 0 ||
      (this.visibleAttributes && this.visibleAttributes.length > 0) ||
      (this.moreInfoDesignation &&
        this.moreInfoDesignation.summary &&
        this.moreInfoDesignation.summary.length > 0)
    ) {
      this.hasPreviewContent = true;
    }
  }

  generateImageUrl(image_key: string): string {
    if (!image_key) {
      return '';
    }
    if (!environment.imgServiceUrl) {
      return '';
    }
    const base_enc = {
      key: image_key,
      bucket: 'idonate-image-service',
      edits: {
        resize: {
          fit: 'outside',
          width: 300,
          height: 168
        }
      }
    };
    const encoded = btoa(JSON.stringify(base_enc));
    return environment.imgServiceUrl + encoded;
  }

  constructor(private settings: AppSettings) {
    this.featureEnabled =
      this.settings.getValue('properties')['designation_info_mode'] ==
      'default';
    if (this.featureEnabled) {
      const designations = this.settings.getValue('organization').designations;
      // server will now pre-filter and pre-sort designations
      this.availableDesignations = designations.filter(item => item.is_active);
    }
  }
}
